import { render, staticRenderFns } from "./Istruzioni.vue?vue&type=template&id=2ce2de46&"
import script from "./Istruzioni.vue?vue&type=script&lang=js&"
export * from "./Istruzioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports